'use strict'

/**
 * un-escape special characters in the given string of html.
 *
 * @param  {String} html
 * @return {String}
 */

module.exports = function (html) {
  return String(html)
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, '\'')
    .replace(/&#x3A;/g, ':')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
}



//////////////////
// WEBPACK FOOTER
// /builds/BootPM/classic.yarnpkg.cn/node_modules/unescape-html/index.js
// module id = ../../node_modules/unescape-html/index.js
// module chunks = 6